var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLifepointsLogo = function SvgLifepointsLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 173 36"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#lifepoints-logo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#303F9F",
    d: "M15.647 30.148H2.777V3.562c0-.509-.38-.89-.758-.89H1.01c-.505 0-.884.381-.884.763v28.113c0 .509.253.89.757.89H15.52c.506 0 .884-.382.884-.763v-.637c0-.508-.252-.89-.757-.89ZM20.695 11.195h-.758a.866.866 0 0 0-.883.89v19.59c0 .509.253.89.757.89h.884c.504 0 .883-.381.883-.763V12.085c.126-.509-.252-.89-.757-1.018l-.126.128ZM20.316 2.035c-1.01 0-1.893.764-1.893 1.781v.128c-.126 1.017.631 1.908 1.767 2.035 1.01.127 1.893-.636 2.019-1.781v-.254c0-.89-.757-1.781-1.893-1.909.126 0 0 0 0 0ZM36.972 11.194H31.42V9.286c0-3.689 1.514-5.724 4.038-5.724 2.145 0 3.533 1.145 3.533 2.926v.508c0 .128 0 .382.127.51.126.126.252.254.504.254h1.01a.693.693 0 0 0 .63-.382c.127-.254.127-.636.127-.89 0-3.18-2.272-5.216-5.93-5.216-2.398 0-6.563 1.018-6.563 8.269v1.653h-2.902c-.378 0-.63.255-.63.636v1.017c0 .383.252.637.63.637h3.029v18.19c0 .51.252.891.757.891h.883c.505 0 .883-.381.883-.763V13.357h5.426c.379 0 .631-.255.631-.636v-1.017c0-.255-.252-.51-.63-.51 0-.127 0-.127 0 0ZM48.834 10.685c-6.057-.127-11.23 4.707-11.357 10.94v.255c0 6.36 4.922 11.067 11.736 11.067 3.028.127 5.93-.89 8.075-2.926.379-.254.505-.89.253-1.272l-.126-.127-.253-.382c-.252-.381-.757-.509-1.136-.127H55.9c-1.892 1.654-4.29 2.417-6.688 2.417-2.65.127-5.3-1.018-7.192-2.926-1.514-1.654-2.271-3.943-2.019-6.106h18.297a.96.96 0 0 0 .63-.254.976.976 0 0 0 .253-.636c-.505-7.251-5.678-9.923-10.347-9.923Zm7.823 8.778H40.38c1.009-3.817 4.542-6.488 8.454-6.36 3.912-.382 7.319 2.416 7.823 6.36ZM73.692 2.672H63.22c-.505 0-.884.381-.884.763v28.113c0 .509.253.89.758.89h.883c.505 0 .883-.254.883-.763V20.608h8.707c5.047 0 8.58-3.69 8.58-8.905 0-2.29-.757-4.58-2.27-6.36-1.389-1.781-3.786-2.799-6.184-2.671Zm5.93 9.031c0 3.944-2.523 6.615-6.182 6.615h-8.455V4.961h8.455c3.66 0 6.183 2.799 6.183 6.742ZM115.838 2.035c-1.009 0-1.893.764-1.893 1.781v.128c-.126 1.017.631 1.908 1.767 2.035 1.009.127 1.893-.636 2.019-1.781v-.254c0-.89-.757-1.781-1.893-1.909.126 0 .126 0 0 0ZM116.343 11.194h-.757a.866.866 0 0 0-.884.89v19.591c0 .509.253.89.758.89h.883c.505 0 .883-.381.883-.763V12.085c.126-.51-.252-.89-.883-.89.126-.128 0-.128 0 0ZM131.99 10.685c-3.029 0-5.931 1.654-7.319 4.453v-3.053c0-.509-.252-.89-.757-.89h-.757c-.505 0-.884.381-.884.763v19.59c0 .509.253.89.758.89h.883c.505 0 .883-.254.883-.763V21.626c.126-6.743 4.795-8.524 7.319-8.524s6.309.891 6.309 7.251v11.322c0 .509.253.89.757.89h.884c.504 0 .883-.381.883-.763V20.353c-.126-6.106-3.281-9.668-8.959-9.668ZM156.596 26.078h-1.009c-.127 0-.379 0-.505.255-.126.127-.126.381-.126.508 0 .255.126.51.126.764 0 1.653-1.262 3.053-3.029 3.18h-.252c-2.398 0-3.533-1.527-3.533-4.707V13.484h6.183c.378 0 .631-.254.631-.508v-1.018c0-.382-.253-.636-.505-.636h-6.309V5.47c0-.381-.253-.763-.757-.763h-.505c-.379 0-.757.382-.883.763l-.505 5.852h-3.029c-.378 0-.631.254-.631.636v1.017c0 .382.253.637.631.637H145.744v12.593c0 4.707 2.019 7.124 5.931 7.124 3.407 0 5.678-2.035 5.678-5.216 0-.381 0-.763-.126-1.145 0-.636-.252-.89-.631-.89ZM168.205 21.116 165.05 20.1c-2.145-.636-3.154-1.781-3.154-3.435.126-2.163 1.893-3.816 4.038-3.689h.126c1.514 0 2.776.763 3.533 2.035.252.382.631.636 1.136.51l.504-.128c.253 0 .505-.255.631-.509a.812.812 0 0 0 0-.763c-1.135-2.163-3.407-3.562-5.804-3.435a7.265 7.265 0 0 0-4.921 1.908c-1.136 1.145-1.767 2.672-1.767 4.198 0 2.672 1.64 4.58 4.921 5.47l3.155 1.018c2.145.763 3.155 1.908 3.155 3.562 0 2.162-2.019 3.816-4.543 3.816-2.019.127-3.786-.89-4.921-2.544-.253-.382-.757-.636-1.136-.382l-.631.255c-.252 0-.505.254-.631.508a.818.818 0 0 0 0 .764c1.514 2.544 4.29 3.943 7.193 3.816 4.669 0 7.066-3.053 7.066-6.106 0-2.035-.883-4.58-4.795-5.852Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5B00",
    d: "M97.667 8.904c.767 0 1.388-.626 1.388-1.399s-.621-1.4-1.388-1.4c-.767 0-1.388.627-1.388 1.4 0 .773.621 1.4 1.388 1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9D00",
    d: "M97.667 11.958a1.14 1.14 0 0 0 1.136-1.145 1.14 1.14 0 0 0-1.136-1.145 1.14 1.14 0 0 0-1.135 1.145 1.14 1.14 0 0 0 1.135 1.145Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD400",
    d: "M97.668 14.502a.887.887 0 0 0 .883-.89.887.887 0 0 0-.883-.891.887.887 0 0 0-.884.89c0 .492.396.89.884.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B3ED00",
    d: "M97.668 16.664a.633.633 0 0 0 .63-.636.634.634 0 0 0-.63-.636.634.634 0 0 0-.631.636c0 .352.282.636.63.636Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0FEAAC",
    d: "M97.668 18.318a.38.38 0 0 0 .378-.382.38.38 0 0 0-.378-.381.38.38 0 0 0-.379.381c0 .211.17.382.379.382Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1CE3E8",
    d: "M97.667 19.59c.07 0 .126-.057.126-.127a.127.127 0 0 0-.126-.127.127.127 0 0 0-.126.127c0 .07.056.127.126.127Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5B00",
    d: "M93.25 9.668c.767 0 1.389-.627 1.389-1.4 0-.772-.622-1.399-1.388-1.399-.767 0-1.389.627-1.389 1.4 0 .772.622 1.399 1.389 1.399Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9D00",
    d: "M94.387 12.594a1.14 1.14 0 0 0 1.135-1.145 1.14 1.14 0 0 0-1.135-1.145 1.14 1.14 0 0 0-1.136 1.145 1.14 1.14 0 0 0 1.136 1.145Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD400",
    d: "M95.27 14.883a.887.887 0 0 0 .883-.89.887.887 0 0 0-.884-.89.887.887 0 0 0-.883.89c0 .492.396.89.883.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B3ED00",
    d: "M96.153 16.919c.349 0 .631-.285.631-.637a.634.634 0 0 0-.63-.636.633.633 0 0 0-.632.636c0 .352.283.637.631.637Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0FEAAC",
    d: "M96.784 18.573a.38.38 0 0 0 .379-.382.38.38 0 0 0-.379-.382.38.38 0 0 0-.379.382c0 .21.17.382.38.382Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1CE3E8",
    d: "M97.289 19.717c.07 0 .126-.057.126-.127a.127.127 0 0 0-.126-.127.127.127 0 0 0-.126.127c0 .07.056.127.126.127Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5B00",
    d: "M89.213 11.958c.767 0 1.388-.627 1.388-1.4 0-.772-.621-1.399-1.388-1.399-.766 0-1.388.627-1.388 1.4 0 .772.622 1.399 1.388 1.399Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9D00",
    d: "M91.358 14.247a1.14 1.14 0 0 0 1.136-1.145 1.14 1.14 0 0 0-1.136-1.145 1.14 1.14 0 0 0-1.136 1.145 1.14 1.14 0 0 0 1.136 1.145Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD400",
    d: "M93.125 16.155a.887.887 0 0 0 .883-.89.887.887 0 0 0-.883-.89.887.887 0 0 0-.883.89c0 .492.395.89.883.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B3ED00",
    d: "M94.639 17.682c.348 0 .63-.285.63-.636a.634.634 0 0 0-.63-.636.633.633 0 0 0-.63.636c0 .351.281.636.63.636Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0FEAAC",
    d: "M95.901 18.954a.38.38 0 0 0 .379-.382.38.38 0 0 0-.379-.382.38.38 0 0 0-.379.382c0 .21.17.382.379.382Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1CE3E8",
    d: "M96.91 19.845c.07 0 .127-.057.127-.128a.127.127 0 0 0-.126-.127.127.127 0 0 0-.127.127c0 .07.057.128.127.128Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5B00",
    d: "M86.437 15.138c.767 0 1.388-.626 1.388-1.4 0-.772-.621-1.398-1.388-1.398-.767 0-1.388.626-1.388 1.399s.621 1.4 1.388 1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9D00",
    d: "M89.213 16.537a1.14 1.14 0 0 0 1.136-1.145 1.14 1.14 0 0 0-1.136-1.144 1.14 1.14 0 0 0-1.136 1.144 1.14 1.14 0 0 0 1.136 1.145Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD400",
    d: "M91.737 17.682a.887.887 0 0 0 .883-.89.887.887 0 0 0-.883-.89.887.887 0 0 0-.883.89c0 .491.395.89.883.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B3ED00",
    d: "M93.63 18.954c.348 0 .63-.285.63-.636a.633.633 0 0 0-.63-.636.634.634 0 0 0-.631.636c0 .351.282.636.63.636Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0FEAAC",
    d: "M95.27 19.717a.38.38 0 0 0 .379-.381.38.38 0 0 0-.379-.382.38.38 0 0 0-.378.381c0 .211.17.382.378.382Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1CE3E8",
    d: "M96.658 20.226c.07 0 .126-.057.126-.127a.127.127 0 0 0-.126-.127.127.127 0 0 0-.126.127c0 .07.056.127.126.127Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5B00",
    d: "M84.796 19.845c.767 0 1.388-.627 1.388-1.4 0-.773-.62-1.4-1.388-1.4-.766 0-1.388.627-1.388 1.4 0 .773.622 1.4 1.388 1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9D00",
    d: "M87.95 20.1a1.14 1.14 0 0 0 1.136-1.146 1.14 1.14 0 0 0-1.135-1.145 1.14 1.14 0 0 0-1.136 1.145 1.14 1.14 0 0 0 1.136 1.145Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD400",
    d: "M90.728 20.353a.887.887 0 0 0 .883-.89.887.887 0 0 0-.883-.89.887.887 0 0 0-.884.89c0 .492.396.89.884.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B3ED00",
    d: "M93.125 20.608c.348 0 .63-.285.63-.636a.634.634 0 0 0-.63-.636.633.633 0 0 0-.631.636c0 .351.282.636.63.636Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0FEAAC",
    d: "M95.017 20.608a.38.38 0 0 0 .379-.382.38.38 0 0 0-.379-.381.38.38 0 0 0-.378.381c0 .21.17.382.379.382Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1CE3E8",
    d: "M96.532 20.608c.07 0 .126-.057.126-.128a.127.127 0 0 0-.126-.127.127.127 0 0 0-.126.127c0 .07.056.128.126.128Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5B00",
    d: "M84.796 24.424c.767 0 1.388-.626 1.388-1.4 0-.772-.62-1.399-1.388-1.399-.766 0-1.388.627-1.388 1.4 0 .773.622 1.4 1.388 1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9D00",
    d: "M87.95 23.66a1.14 1.14 0 0 0 1.136-1.144 1.14 1.14 0 0 0-1.135-1.145 1.14 1.14 0 0 0-1.136 1.145 1.14 1.14 0 0 0 1.136 1.145Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD400",
    d: "M90.728 22.898a.887.887 0 0 0 .883-.89.887.887 0 0 0-.883-.891.887.887 0 0 0-.884.89c0 .492.396.89.884.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B3ED00",
    d: "M93.125 22.134c.348 0 .63-.285.63-.636a.633.633 0 0 0-.63-.636.633.633 0 0 0-.631.636c0 .351.282.636.63.636Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0FEAAC",
    d: "M95.017 21.626a.38.38 0 0 0 .379-.382.38.38 0 0 0-.379-.382.38.38 0 0 0-.378.382c0 .21.17.382.379.382Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1CE3E8",
    d: "M96.532 21.117c.07 0 .126-.057.126-.128a.127.127 0 0 0-.126-.127.127.127 0 0 0-.126.128c0 .07.056.127.126.127Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5B00",
    d: "M86.31 28.749c.767 0 1.388-.627 1.388-1.4 0-.772-.621-1.399-1.388-1.399-.766 0-1.388.627-1.388 1.4 0 .772.622 1.399 1.388 1.399Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9D00",
    d: "M89.213 26.84a1.14 1.14 0 0 0 1.136-1.144 1.14 1.14 0 0 0-1.136-1.145 1.14 1.14 0 0 0-1.136 1.145 1.14 1.14 0 0 0 1.136 1.145Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD400",
    d: "M91.61 25.187a.887.887 0 0 0 .884-.89.887.887 0 0 0-.883-.89.887.887 0 0 0-.884.89c0 .492.396.89.884.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B3ED00",
    d: "M93.63 23.788c.348 0 .63-.285.63-.636a.633.633 0 0 0-.63-.636.634.634 0 0 0-.631.636c0 .351.282.636.63.636Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0FEAAC",
    d: "M95.27 22.516a.38.38 0 0 0 .379-.381.38.38 0 0 0-.379-.382.38.38 0 0 0-.378.382c0 .21.17.381.378.381Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1CE3E8",
    d: "M96.658 21.499c.07 0 .126-.057.126-.128a.127.127 0 0 0-.126-.127.127.127 0 0 0-.126.127c0 .07.056.128.126.128Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5B00",
    d: "M89.213 32.311c.767 0 1.388-.626 1.388-1.399s-.621-1.4-1.388-1.4c-.766 0-1.388.627-1.388 1.4 0 .773.622 1.4 1.388 1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9D00",
    d: "M91.358 29.512a1.14 1.14 0 0 0 1.136-1.145 1.14 1.14 0 0 0-1.136-1.144 1.14 1.14 0 0 0-1.136 1.145 1.14 1.14 0 0 0 1.136 1.144Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD400",
    d: "M93.125 27.095a.887.887 0 0 0 .883-.89.887.887 0 0 0-.883-.89.887.887 0 0 0-.883.89c0 .492.395.89.883.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B3ED00",
    d: "M94.639 25.06c.348 0 .63-.284.63-.636a.634.634 0 0 0-.63-.636.633.633 0 0 0-.63.636c0 .352.281.636.63.636Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0FEAAC",
    d: "M95.901 23.28a.38.38 0 0 0 .379-.382.38.38 0 0 0-.379-.382.38.38 0 0 0-.379.382c0 .21.17.381.379.381Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1CE3E8",
    d: "M96.91 21.88c.07 0 .127-.057.127-.127a.127.127 0 0 0-.126-.128.127.127 0 0 0-.127.128c0 .07.057.127.127.127Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5B00",
    d: "M93.25 34.6c.767 0 1.389-.626 1.389-1.398 0-.773-.622-1.4-1.388-1.4-.767 0-1.389.627-1.389 1.4 0 .772.622 1.399 1.389 1.399Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9D00",
    d: "M94.26 31.293a1.14 1.14 0 0 0 1.136-1.145 1.14 1.14 0 0 0-1.136-1.145 1.14 1.14 0 0 0-1.136 1.145 1.14 1.14 0 0 0 1.136 1.145Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD400",
    d: "M95.27 28.367a.887.887 0 0 0 .883-.89.887.887 0 0 0-.884-.89.887.887 0 0 0-.883.89c0 .492.396.89.883.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B3ED00",
    d: "M95.9 25.696a.634.634 0 0 0 .632-.636.634.634 0 0 0-.631-.636.634.634 0 0 0-.631.636c0 .352.282.636.63.636Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0FEAAC",
    d: "M96.784 23.66a.38.38 0 0 0 .379-.38.38.38 0 0 0-.379-.383.38.38 0 0 0-.379.382c0 .21.17.382.38.382Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1CE3E8",
    d: "M97.289 22.007c.07 0 .126-.057.126-.127a.127.127 0 0 0-.126-.127.127.127 0 0 0-.126.127c0 .07.056.127.126.127Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5B00",
    d: "M97.667 35.364c.767 0 1.388-.627 1.388-1.4 0-.772-.621-1.399-1.388-1.399-.767 0-1.388.627-1.388 1.4 0 .772.621 1.399 1.388 1.399Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9D00",
    d: "M97.667 31.802a1.14 1.14 0 0 0 1.136-1.144 1.14 1.14 0 0 0-1.136-1.145 1.14 1.14 0 0 0-1.135 1.145 1.14 1.14 0 0 0 1.135 1.144Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD400",
    d: "M97.668 28.75a.887.887 0 0 0 .883-.891.887.887 0 0 0-.883-.89.887.887 0 0 0-.884.89c0 .492.396.89.884.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B3ED00",
    d: "M97.668 26.078a.633.633 0 0 0 .63-.636.633.633 0 0 0-.63-.636.633.633 0 0 0-.631.636c0 .351.282.636.63.636Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0FEAAC",
    d: "M97.668 23.915a.38.38 0 0 0 .378-.381.38.38 0 0 0-.378-.382.38.38 0 0 0-.379.382c0 .21.17.381.379.381Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1CE3E8",
    d: "M97.667 22.134c.07 0 .126-.056.126-.127a.127.127 0 0 0-.126-.127.127.127 0 0 0-.126.127c0 .07.056.127.126.127Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5B00",
    d: "M102.21 34.6c.767 0 1.388-.626 1.388-1.398 0-.773-.621-1.4-1.388-1.4-.767 0-1.388.627-1.388 1.4 0 .772.621 1.399 1.388 1.399Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9D00",
    d: "M101.075 31.293a1.14 1.14 0 0 0 1.135-1.145 1.14 1.14 0 0 0-1.135-1.145 1.14 1.14 0 0 0-1.136 1.145 1.14 1.14 0 0 0 1.136 1.145Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD400",
    d: "M100.065 28.368a.887.887 0 0 0 .883-.89.886.886 0 0 0-.883-.891.887.887 0 0 0-.883.89c0 .492.395.89.883.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B3ED00",
    d: "M99.308 25.823c.349 0 .631-.285.631-.636a.634.634 0 0 0-.63-.636.634.634 0 0 0-.632.636c0 .351.283.636.631.636Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0FEAAC",
    d: "M98.677 23.66a.38.38 0 0 0 .378-.38.38.38 0 0 0-.378-.383.38.38 0 0 0-.379.382c0 .21.17.382.379.382Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1CE3E8",
    d: "M98.172 22.007c.07 0 .127-.057.127-.127a.127.127 0 0 0-.127-.127.127.127 0 0 0-.126.127c0 .07.057.127.126.127Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5B00",
    d: "M106.122 32.311c.767 0 1.388-.626 1.388-1.399s-.621-1.4-1.388-1.4c-.767 0-1.388.627-1.388 1.4 0 .773.621 1.4 1.388 1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9D00",
    d: "M104.103 29.512a1.14 1.14 0 0 0 1.136-1.145 1.14 1.14 0 0 0-1.136-1.144 1.14 1.14 0 0 0-1.136 1.145 1.14 1.14 0 0 0 1.136 1.144Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD400",
    d: "M102.21 27.095a.887.887 0 0 0 .883-.89.886.886 0 0 0-.883-.89.886.886 0 0 0-.883.89c0 .492.395.89.883.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B3ED00",
    d: "M101.074 25.442a.633.633 0 0 0 .631-.636.633.633 0 0 0-.631-.636.634.634 0 0 0-.631.636c0 .351.283.636.631.636Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0FEAAC",
    d: "M99.434 23.28a.38.38 0 0 0 .379-.382.38.38 0 0 0-.379-.382.38.38 0 0 0-.379.382c0 .21.17.381.379.381Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1CE3E8",
    d: "M98.55 21.88c.07 0 .127-.057.127-.127a.127.127 0 0 0-.126-.128.127.127 0 0 0-.126.128c0 .07.056.127.126.127Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5B00",
    d: "M109.024 28.749c.766 0 1.388-.627 1.388-1.4 0-.772-.622-1.399-1.388-1.399-.767 0-1.388.627-1.388 1.4 0 .772.621 1.399 1.388 1.399Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9D00",
    d: "M106.248 26.84a1.14 1.14 0 0 0 1.135-1.144 1.14 1.14 0 0 0-1.135-1.145 1.14 1.14 0 0 0-1.136 1.145 1.14 1.14 0 0 0 1.136 1.145Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD400",
    d: "M103.851 25.187a.887.887 0 0 0 .883-.89.887.887 0 0 0-.883-.89.887.887 0 0 0-.884.89c0 .492.396.89.884.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B3ED00",
    d: "M101.705 23.788a.633.633 0 0 0 .631-.636.633.633 0 0 0-.631-.636.634.634 0 0 0-.631.636c0 .351.283.636.631.636Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0FEAAC",
    d: "M100.065 22.516a.38.38 0 0 0 .378-.382.38.38 0 0 0-.378-.381.38.38 0 0 0-.379.381c0 .211.17.382.379.382Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1CE3E8",
    d: "M98.803 21.499c.07 0 .127-.057.127-.128a.127.127 0 0 0-.127-.127.127.127 0 0 0-.126.127c0 .07.057.128.126.128Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5B00",
    d: "M110.034 24.805c.766 0 1.388-.626 1.388-1.399s-.622-1.4-1.388-1.4c-.767 0-1.388.627-1.388 1.4 0 .773.621 1.4 1.388 1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9D00",
    d: "M107.384 23.66a1.14 1.14 0 0 0 1.136-1.144 1.14 1.14 0 0 0-1.136-1.145 1.14 1.14 0 0 0-1.136 1.145 1.14 1.14 0 0 0 1.136 1.145Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD400",
    d: "M104.608 22.898a.887.887 0 0 0 .883-.89.887.887 0 0 0-.883-.891.887.887 0 0 0-.883.89c0 .492.395.89.883.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B3ED00",
    d: "M102.336 22.134a.633.633 0 0 0 .631-.636.633.633 0 0 0-.631-.636.634.634 0 0 0-.631.636c0 .352.283.636.631.636Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0FEAAC",
    d: "M100.443 21.625a.38.38 0 0 0 .379-.381.38.38 0 0 0-.379-.382.38.38 0 0 0-.378.382c0 .21.169.381.378.381Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1CE3E8",
    d: "M98.929 21.116c.07 0 .126-.056.126-.127a.127.127 0 0 0-.126-.127.127.127 0 0 0-.126.127c0 .07.056.127.126.127Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5B00",
    d: "M110.664 19.845c.767 0 1.388-.627 1.388-1.4 0-.773-.621-1.4-1.388-1.4-.766 0-1.388.627-1.388 1.4 0 .773.622 1.4 1.388 1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9D00",
    d: "M107.384 20.1a1.14 1.14 0 0 0 1.136-1.146 1.14 1.14 0 0 0-1.136-1.145 1.14 1.14 0 0 0-1.136 1.145 1.14 1.14 0 0 0 1.136 1.145Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD400",
    d: "M104.608 20.353a.886.886 0 0 0 .883-.89.887.887 0 0 0-.883-.89.887.887 0 0 0-.883.89c0 .492.395.89.883.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B3ED00",
    d: "M102.336 20.608a.633.633 0 0 0 .631-.636.633.633 0 0 0-.631-.636.633.633 0 0 0-.63.636c0 .351.282.636.63.636Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0FEAAC",
    d: "M100.443 20.608a.38.38 0 0 0 .379-.382.38.38 0 0 0-.379-.381.38.38 0 0 0-.378.381c0 .211.169.382.378.382Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1CE3E8",
    d: "M98.929 20.608c.07 0 .126-.057.126-.128a.127.127 0 0 0-.126-.127.127.127 0 0 0-.126.127c0 .07.056.128.126.128Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5B00",
    d: "M109.529 15.647c.767 0 1.388-.627 1.388-1.4 0-.772-.621-1.399-1.388-1.399-.766 0-1.388.627-1.388 1.4 0 .772.622 1.399 1.388 1.399Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9D00",
    d: "M106.626 17.046a1.14 1.14 0 0 0 1.136-1.145 1.14 1.14 0 0 0-1.136-1.145 1.14 1.14 0 0 0-1.135 1.145 1.14 1.14 0 0 0 1.135 1.145Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD400",
    d: "M104.229 18.19a.886.886 0 0 0 .883-.89.887.887 0 0 0-.883-.89.887.887 0 0 0-.883.89c0 .492.395.89.883.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B3ED00",
    d: "M101.705 18.954a.633.633 0 0 0 .631-.636.633.633 0 0 0-.631-.636.634.634 0 0 0-.631.636c0 .351.283.636.631.636Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0FEAAC",
    d: "M100.065 19.717a.38.38 0 0 0 .378-.381.38.38 0 0 0-.378-.382.38.38 0 0 0-.379.382c0 .21.17.381.379.381Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1CE3E8",
    d: "M98.803 20.226c.07 0 .127-.057.127-.127a.127.127 0 0 0-.127-.127.127.127 0 0 0-.126.127c0 .07.057.127.126.127Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5B00",
    d: "M106.122 11.958c.767 0 1.388-.627 1.388-1.4 0-.772-.621-1.399-1.388-1.399-.767 0-1.388.627-1.388 1.4 0 .772.621 1.399 1.388 1.399Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9D00",
    d: "M103.977 14.247a1.14 1.14 0 0 0 1.135-1.145 1.14 1.14 0 0 0-1.135-1.145 1.14 1.14 0 0 0-1.136 1.145 1.14 1.14 0 0 0 1.136 1.145Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD400",
    d: "M102.21 16.155a.887.887 0 0 0 .883-.89.886.886 0 0 0-.883-.89.886.886 0 0 0-.883.89c0 .492.395.89.883.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B3ED00",
    d: "M100.696 17.81a.634.634 0 0 0 .631-.637.634.634 0 0 0-.631-.636.633.633 0 0 0-.631.636c0 .351.282.636.631.636Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0FEAAC",
    d: "M99.434 18.954a.38.38 0 0 0 .379-.382.38.38 0 0 0-.379-.382.38.38 0 0 0-.379.382c0 .21.17.382.379.382Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1CE3E8",
    d: "M98.55 19.845c.07 0 .127-.057.127-.128a.127.127 0 0 0-.126-.127.127.127 0 0 0-.126.127c0 .07.056.128.126.128Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5B00",
    d: "M102.21 9.668c.767 0 1.388-.627 1.388-1.4 0-.772-.621-1.399-1.388-1.399-.767 0-1.388.627-1.388 1.4 0 .772.621 1.399 1.388 1.399Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9D00",
    d: "M101.075 12.466a1.14 1.14 0 0 0 1.135-1.144 1.14 1.14 0 0 0-1.135-1.145 1.14 1.14 0 0 0-1.136 1.145 1.14 1.14 0 0 0 1.136 1.145Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD400",
    d: "M100.065 14.883a.887.887 0 0 0 .883-.89.887.887 0 0 0-.883-.89.887.887 0 0 0-.883.89c0 .492.395.89.883.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B3ED00",
    d: "M99.308 16.919c.349 0 .631-.285.631-.637a.634.634 0 0 0-.63-.636.634.634 0 0 0-.632.636c0 .352.283.637.631.637Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0FEAAC",
    d: "M98.677 18.573a.38.38 0 0 0 .378-.382.38.38 0 0 0-.378-.382.38.38 0 0 0-.379.382c0 .21.17.382.379.382Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1CE3E8",
    d: "M98.172 19.717c.07 0 .127-.057.127-.127a.127.127 0 0 0-.127-.127.127.127 0 0 0-.126.127c0 .07.057.127.126.127Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "lifepoints-logo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h173v36H0z"
  })))));
};
export default SvgLifepointsLogo;